import { FilterFn } from "@tanstack/react-table";
import { normalizeString } from "./common";

export const strictEqualityFilter: FilterFn<any> = (row, columnId, value) => {
  const val = normalizeString(value);
  const colVal = normalizeString(row.getValue(columnId));

  return val === colVal;
};
